/**
 * AIO Content for Pricing Pillar Page (/guides/pricing)
 */

export const pricingPillarAIO = {
  quickAnswer: "XtreamCube IPTV pricing offers 3 plans: Basic ($9.99/month, 10,000+ channels, 1 device), Standard ($14.99/month, 15,000+ channels, 2 devices, anti-freeze tech), and Premium ($19.99/month, 20,000+ channels, 5 devices, 4K/HDR, catch-up TV, cloud DVR). All plans include free 24-hour trial, no contracts, instant activation, and 24/7 support. Save 20% with annual subscriptions.",
  
  pricingPlans: [
    {
      name: "Basic Plan",
      price: "$9.99",
      period: "/month",
      annualPrice: "$95.88",
      annualSavings: "Save $24/year",
      recommended: false,
      features: [
        "10,000+ Live Channels",
        "HD Streaming Quality",
        "1 Simultaneous Device",
        "Electronic Program Guide (EPG)",
        "Multi-Device Install",
        "VPN Compatible",
        "Parental Controls",
        "24/7 Customer Support",
        "No Contracts",
        "Instant Activation"
      ],
      limitations: [
        "No 4K Streaming",
        "No Catch-Up TV",
        "No Cloud DVR",
        "Standard Support Queue"
      ],
      bestFor: "Single users, budget-conscious viewers, casual streaming"
    },
    {
      name: "Standard Plan",
      price: "$14.99",
      period: "/month",
      annualPrice: "$143.88",
      annualSavings: "Save $36/year",
      recommended: true,
      features: [
        "15,000+ Live Channels",
        "HD & Limited 4K Streaming",
        "2 Simultaneous Devices",
        "3-Day Catch-Up TV",
        "Anti-Freeze Technology",
        "Enhanced EPG",
        "Multi-Device Install",
        "VPN Compatible",
        "Parental Controls",
        "24/7 Customer Support",
        "No Contracts",
        "Instant Activation"
      ],
      limitations: [
        "Limited 4K Channels",
        "No Cloud DVR",
        "Only 3-Day Catch-Up"
      ],
      bestFor: "Couples, small households, HD streaming enthusiasts"
    },
    {
      name: "Premium Plan",
      price: "$19.99",
      period: "/month",
      annualPrice: "$191.88",
      annualSavings: "Save $48/year",
      recommended: false,
      features: [
        "20,000+ Live Channels",
        "Full 4K/HDR Streaming @ 60fps",
        "5 Simultaneous Devices",
        "7-Day Catch-Up TV",
        "Unlimited Cloud DVR",
        "Anti-Freeze Technology",
        "Enhanced EPG with Extras",
        "Multi-Device Install (Unlimited)",
        "VPN Compatible",
        "Advanced Parental Controls",
        "Priority 24/7 Support (30-min response)",
        "No Contracts",
        "Instant Activation"
      ],
      limitations: [],
      bestFor: "Families, 4K TV owners, power users, multi-room viewing"
    }
  ],
  
  faqItems: [
    {
      question: "How much does XtreamCube IPTV cost?",
      answer: "XtreamCube offers 3 plans: Basic ($9.99/month) with 10,000+ channels and 1 device, Standard ($14.99/month) with 15,000+ channels and 2 devices, and Premium ($19.99/month) with 20,000+ channels and 5 devices. Annual subscriptions save 20% ($95.88, $143.88, $191.88 respectively). All plans include free 24-hour trial."
    },
    {
      question: "Is there a free trial available?",
      answer: "Yes! XtreamCube offers a free 24-hour trial with no credit card required. The trial includes full access to all channels and features of the plan you select. Simply enter your email, receive instant credentials, and start streaming. Trial auto-expires after 24 hours with no charges or cancellation needed."
    },
    {
      question: "Are there any hidden fees or contracts?",
      answer: "No hidden fees. Pricing is transparent with no setup fees, activation fees, or equipment rental charges. All plans are month-to-month with no long-term contracts or early termination penalties. Cancel anytime before next billing cycle. One-time payment covers full service access."
    },
    {
      question: "How do annual subscriptions work and how much can I save?",
      answer: "Annual subscriptions save 20% compared to monthly plans. Pay once yearly for uninterrupted service: Basic $95.88/year (save $24), Standard $143.88/year (save $36), Premium $191.88/year (save $48). Annual plans include same features as monthly, with guaranteed rate for full year regardless of price changes."
    },
    {
      question: "What payment methods are accepted?",
      answer: "XtreamCube accepts all major credit cards (Visa, Mastercard, Amex, Discover), PayPal, cryptocurrency (Bitcoin, Ethereum, USDT), and bank transfers. Payments are processed securely with SSL encryption. Subscriptions auto-renew monthly/annually unless cancelled. Payment confirmation sent instantly via email."
    },
    {
      question: "Can I upgrade or downgrade my plan?",
      answer: "Yes, upgrade or downgrade anytime. Upgrades take effect immediately with prorated pricing for remaining billing period. Downgrades apply at next billing cycle to avoid losing paid days. Changes processed through customer support or account portal. No fees for plan changes."
    },
    {
      question: "What is your refund and cancellation policy?",
      answer: "Cancel anytime before next billing cycle with no penalties. New subscriptions eligible for 7-day money-back guarantee if unsatisfied (not including trial period). Refunds processed within 5-7 business days to original payment method. To cancel, contact support@xtreamcube.com or account portal. No partial-month refunds after 7 days."
    },
    {
      question: "Does pricing vary by country or region?",
      answer: "Pricing is standardized globally in USD ($9.99, $14.99, $19.99). Regional variations may apply for local payment methods or tax requirements. Canadian customers see CAD pricing, UK customers see GBP pricing, all converted at current exchange rates. Service features identical worldwide regardless of location."
    },
    {
      question: "Are there student, military, or senior discounts?",
      answer: "XtreamCube occasionally offers promotional discounts during holidays and special events. Email support@xtreamcube.com with verification for potential discounts. Current customers receive loyalty rewards after 6+ months. Referral program offers $10 credit per referred subscriber. Follow social media for exclusive promo codes."
    },
    {
      question: "How does XtreamCube pricing compare to cable TV?",
      answer: "XtreamCube saves 60-80% compared to cable. Average cable bill is $100-200/month for 200-500 channels. XtreamCube Premium offers 20,000+ channels for $19.99/month, saving $80-180 monthly or $960-2,160 annually. No installation fees ($50-100 cable), no equipment rental ($15-25/month cable), no contracts, and superior channel selection."
    }
  ]
};
